import { createClient } from "@spf/api-client";
import { clearSession, readTokens, writeTokens } from "./session.js";

export const api = createClient({
  getTokens: readTokens,
  onTokens: writeTokens,
  onSignedOut: clearSession,
});
